import React from 'react';
import CompaniesTable from '../components/CompaniesTable';

export function Companies() {
  return <CompaniesTable />;
}
